import { useState } from 'react'

import FormsyInput from '@components/Textfield/withFormsy'
import Select from '@components/Select/RequiredSelectWithFormsy'
import { withTranslate } from '@i18n/utils'

import { DOCUMENT_TYPES, DOCUMENT_TYPE_NUMBER_PATTERN } from './constants'
import { fillDocumentNumberMask, stripDocumentNumber } from './utils'

const DocumentDataFields = ({ documentType, documentNumber, hideType, fieldClassName = '', translate: t }) => {
    const [documentTypeValue, setDocumentType] = useState(documentType)
    const [documentNumberValue, setDocumentNumber] = useState(() =>
        fillDocumentNumberMask(documentType, documentNumber)
    )

    const tLabel = key => t(`document.data.${key}`)

    return (
        <div className={!hideType ? 'row' : ''}>
            {!hideType && (
                <div className={`${fieldClassName} mb-3`}>
                    <Select
                        options={DOCUMENT_TYPES}
                        getSelectValue={() => DOCUMENT_TYPES.find(({ value }) => value === documentTypeValue)}
                        name="documentType"
                        placeholder={tLabel('type')}
                        value={documentTypeValue}
                        onChange={newValue => {
                            setDocumentType(newValue)
                            setDocumentNumber('')
                        }}
                        required
                    />
                </div>
            )}
            <div className={fieldClassName}>
                <FormsyInput
                    value={documentNumberValue}
                    onChange={event => setDocumentNumber(event.currentTarget.value)}
                    name="documentNumber"
                    placeholder={tLabel('documentNumber')}
                    required
                    onFocus={() => setDocumentNumber(stripDocumentNumber(documentNumberValue))}
                    onBlur={() =>
                        setDocumentNumber(
                            fillDocumentNumberMask(documentTypeValue, documentNumberValue, documentNumberValue)
                        )
                    }
                    validationErrors={{
                        matchRegexp: documentTypeValue
                            ? tLabel(`validation.${documentTypeValue?.toLowerCase()}`)
                            : undefined,
                    }}
                    validations={{
                        matchRegexp: DOCUMENT_TYPE_NUMBER_PATTERN[documentTypeValue] || /^.+$/,
                    }}
                    touched
                />
            </div>
        </div>
    )
}

export default withTranslate(DocumentDataFields)
